<template>
    <div class="views-content--colour">
        <banner-colour :data="data.hero"></banner-colour>

        <!-- elements -->
        <div v-for="(element, index) in data.elements" :key="element.id">
            <component 
                :class="elementClass(element.vueName, index)" 
                :is="element.vueName" 
                :data="alteredElements[index]"
                @addNeighbourClass="addNeighbourClassHandle"
            />
        </div>
    </div>
    
</template>

<script>
    import viewsElementClasses from '../mixins/viewsElementClasses';
    import { BannerColour } from "../components";

    // elements
    import { ElementAccordion,ElementBackgroundImage, ElementContent, ElementCTA, ElementColours,ElementImage, ElementLinks, ElementImages, ElementProducts, ElementSplitSlider, ElementTiles, ElementVideo, ElementPercentage} from "../components";

    export default {
        name: "v-colour",
        mixins: [viewsElementClasses],
        components: {
            BannerColour,
            // Elements
            ElementAccordion,
            ElementBackgroundImage,
            ElementColours,
            ElementContent,
            ElementCTA,
            ElementLinks,
            ElementImages,
            ElementImage,
            ElementProducts,
            ElementSplitSlider,
            ElementTiles,
            ElementVideo,
            ElementPercentage
        },
        props: {
            data: {
                type: Object
            }
        }
    };
</script>